export default function validatePasswordResetReq (email, confirmEmail) {
  function validEmail(address) {
    if (address.indexOf('@') < 0) {
      return false
    } else if (address.indexOf('.') < 0) {
      return false
    } else return true
  }

  if (!email) {
    return {emailErr: 'Email address is required.'}
  } else if (email !== confirmEmail) {
    return {confirmEmailErr: 'Email and confirmation should match.'}
  } else if (!validEmail(email)) {
    return {emailErr: 'Email not a valid address.'}
  } else return null
}


// WEBPACK FOOTER //
// ./src/helpers/users/validatePasswordResetReq.js